<template>
  <div>
    <sc-link
      v-if="fields && fields.cta"
      :field="fields.cta"
      class="c-cta--secondary"
      :class="fields.cta.value.class"
    />
  </div>
</template>

<script>
import { Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-CTA-Secondary',
  components: {
    ScLink: Link
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>
<style lang="scss">
@import '~@/assets/scss/components/cta.scss';
</style>
